import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {NzModalSubject} from "ng-zorro-antd";


@Component({
  selector: 'app-pop-box',
  templateUrl: './pop-box.component.html',
  styleUrls: ['./pop-box.component.css']
})
export class PopBoxComponent implements OnInit {
  constructor(private router: Router,
  private subject:NzModalSubject) {}

  ngOnInit() {
  }
  cancel(){
    this.subject.destroy("onOk");
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/pop-box/pop-box.component.ts